<template>
    <v-overlay :value="visible" :color="color" :opacity="opacity">
      <v-progress-circular
        indeterminate
        size="48"
        :color="spinnerColor"
      ></v-progress-circular>
    </v-overlay>
</template>

<script>
export default {
    props: {
        visible: {
            default: false,
            type: Boolean,
        },
        color: {
            default: '#ffffff',
            type: String,
        },
        spinnerColor: {
            default: '#9E9E9E',
            type: String,
        },
        opacity: {
            default: 0.95,
            type: Number,
        }
    }
}
</script>